<div class="equis" (click)="onCancel()">X</div>
<h1 class="almacen-title">Almacén</h1>
<div class="almacen-line"></div>
<div class="desc-superior-almacen">
  Coloca un nombre y una descripción a tu almacén
</div>

<div class="form-container">
  <form>
    <div class="campos">
      <mat-form-field appearance="legacy" class="nombre-almacen">
        <mat-label>Nombre del almacén</mat-label>
        <mat-icon matPrefix>panorama_fish_eye</mat-icon>
        <input matInput type="text" />
      </mat-form-field>
      <mat-form-field appearance="legacy" class="desc-almacen">
        <mat-label class="label-desc" style="margin-top: 30px;">
          Descripción del almacén
        </mat-label>
        <mat-icon matPrefix>panorama_fish_eye</mat-icon>
        <textarea matInput name="" placeholder="" id=""></textarea>
      </mat-form-field>
      <div class="botones">
        <button (click)="onCancel()" mat-button class="btn btn-cancelar">
          Cancelar
        </button>
        <button mat-button class="btn btn-continuar">
          Continuar
        </button>
      </div>
    </div>
  </form>
</div>

<div class="row cards"></div>
